import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/org/$orgId/home",
      params: { orgId: params.orgId },
    });
  },
});
